import { useCallback } from "react";
import { useApiClient } from "@@common";
import { CodeStoreClient } from "../../../api/api";

export const useCodeStoreController = () => {
  const client = useApiClient(CodeStoreClient);

        const deleteCodeFile = useCallback(
          async (fileName: string, codeBaseId: string) => {
            try {
              console.log(`Deleting code file: ${fileName} from code base: ${codeBaseId}`);
              await client.deleteCodeFile(codeBaseId, fileName);
              console.log(`Deleted code file: ${fileName} successfully.`);
            } catch (error) {
              console.error("Failed to delete code file:", error);
              throw error;
            }
          },
          [client]
        );

        return {
            deleteCodeFile,
    };
    }
